"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyticsReducer = exports.analyticsInitialState = void 0;
var immer_1 = require("immer");
var keyBy_1 = __importDefault(require("lodash/keyBy"));
var typesafe_actions_1 = require("typesafe-actions");
var actions_1 = require("../actions");
var utils_1 = require("../utils");
var actions_2 = require("./actions");
exports.analyticsInitialState = {
    duplicateSummaryRowsByDDCId: {},
    supplySummariesByDemandSubAccountUuid: {},
};
exports.analyticsReducer = (0, typesafe_actions_1.createReducer)(exports.analyticsInitialState)
    .handleAction(actions_1.nextHydrate, function (state, _a) {
    var payload = _a.payload;
    return (__assign(__assign({}, state), (0, utils_1.reconcileState)(payload.analytics, exports.analyticsInitialState)));
})
    .handleAction(actions_2.duplicateSummaryRequestAction.success, function (state, _a) {
    var payload = _a.payload;
    return (0, immer_1.produce)(state, function (draftState) {
        draftState.duplicateSummaryRowsByDDCId = (0, keyBy_1.default)(payload, 'deduplicationConfigurationId');
    });
})
    .handleAction(actions_2.getSupplySummaryRequestAction.success, function (state, _a) {
    var _b = _a.payload, demandPartnerUuid = _b.demandPartnerUuid, response = _b.response;
    return (0, immer_1.produce)(state, function (draftState) {
        draftState.supplySummariesByDemandSubAccountUuid[demandPartnerUuid] =
            response;
    });
});
